import { useSyncExternalStore } from "react";

// Minimal pathname router — pushState + popstate, no dependency.
const listeners = new Set<() => void>();
function emit() {
  for (const l of listeners) l();
}
function subscribe(cb: () => void) {
  listeners.add(cb);
  return () => listeners.delete(cb);
}

if (typeof window !== "undefined") {
  window.addEventListener("popstate", emit);
}

export function navigate(to: string, replace = false) {
  if (to === location.pathname + location.search) return;
  if (replace) history.replaceState({}, "", to);
  else history.pushState({}, "", to);
  emit();
  window.scrollTo(0, 0);
}

export function usePath(): string {
  return useSyncExternalStore(
    subscribe,
    () => location.pathname,
    () => "/",
  );
}

/** Match `/play/:pin` style patterns; returns params or null. */
export function match(pattern: string, path: string): Record<string, string> | null {
  const pp = pattern.split("/").filter(Boolean);
  const ap = path.split("/").filter(Boolean);
  if (pp.length !== ap.length) return null;
  const params: Record<string, string> = {};
  for (let i = 0; i < pp.length; i++) {
    if (pp[i].startsWith(":")) params[pp[i].slice(1)] = decodeURIComponent(ap[i]);
    else if (pp[i] !== ap[i]) return null;
  }
  return params;
}

/** An <a> that routes client-side. */
export function Link({
  to,
  children,
  ...rest
}: { to: string; children: React.ReactNode } & React.HTMLAttributes<HTMLElement>) {
  return (
    <span
      role="link"
      tabIndex={0}
      onClick={() => navigate(to)}
      onKeyDown={(e) => {
        if (e.key === "Enter") navigate(to);
      }}
      {...rest}
    >
      {children}
    </span>
  );
}
